<template>
    <div style="position: relative">
        <Headers :title="title" />
        <div class="search-box" v-show="language == 'zh'">
            <div class="search-input" >
                <el-select v-model="valuePavilion" :popper-append-to-body="false" :placeholder="$t('header.choose_role')"  @change="handleChoose()" class="select-style"
                popper-class="select-popper" style="width: 2.3rem">
                    <el-option
                    v-for="item in optionsChooseCn"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    >
                    </el-option>
                </el-select>
                <input class="search-text" type="text" v-model="searchExhibitor"   :placeholder="$t('header.choose_exhibition')" v-if="this.valuePavilion == '100'">
                <input class="search-text" type="text" v-model="searchGoods"  :placeholder="$t('header.choose_goods')" v-else>
                <img src="../../../../src/assets/area/ss.png" class="icon" alt=""  @click="handleSearch" />
            </div>
        </div>
        <div class="search-boxen" v-show="language == 'en'">
            <div class="search-input" >
                <el-select v-model="valuePavilion" :popper-append-to-body="false" :placeholder="$t('header.choose_role')"  @change="handleChoose()" class="select-style"
                popper-class="select-popper">
                    <el-option
                    v-for="item in optionsChooseEn"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    >
                    </el-option>
                </el-select>
                <input class="search-text" type="text" v-model="searchExhibitor"   :placeholder="$t('header.choose_exhibition')" v-if="this.valuePavilion == '100'">
                <input class="search-text" type="text" v-model="searchGoods"  :placeholder="$t('header.choose_goods')" v-else>
                <img src="../../../../src/assets/area/ss.png" class="icon" alt=""  @click="handleSearch" />
            </div>
        </div>
        <div class="search-title">
            <div class="search">{{$t('header').is_search_exhibitor}}</div>
            <div v-show="this.valuePavilion == '100'" class="name">{{$t('header').exhibitor}} ></div>
            <div v-show="this.valuePavilion == '101'" class="name">{{$t('header').exhibits}} ></div>
            <div v-show="this.valuePavilion == '100'" class="content">{{searchExhibitor}}</div>
            <div v-show="this.valuePavilion == '101'" class="content">{{searchGoods}}</div>
        </div>
        <!-- 展商 -->
        <van-row style="padding:0 .28rem .28rem .28rem" v-show="isExhibitors">
            <van-col  class="exhibitior-wrap"  v-for="(item, index) in exhibitorsList" :key="index" span="8" @click="goExhibitorDetail(item.id, item.exhibition_id,item.vhall.id)">
                <template>
                    <div class="exhibitior-wrap-img">
                        <img v-if="item.is_store == 0" @click.stop="collectExhibitors(item)" class="new-store" src="~statics/mobileShouye/newUnstore.png">
                        <img v-if="item.is_store == 1" @click.stop="cancelCollectExhibitors(item)" class="new-store" src="~statics/mobileShouye/newStore.png">
                        <img class="productImg" :src="item.company && item.company.logo_url || logo" alt="" />
                    </div>
                    <div class="exhibitior-wrap-title">
                        <span class="exhibitior-wrap-title-name">{{language == 'zh'? item.company.name : item.company.locales.en && item.company.locales.en.name || ''}}</span>
                        <div class="company-place">
                            <img class="icon" src="~statics/mobileShouye/location.png" alt="">
                            <span class="address">{{item.company.address || '暂无'}}</span>
                        </div>
                        <div class="exhibitor-place">
                            <span class="address">{{$t('header').exhibition}}：{{language == 'zh'? item.exhibition_name && item.exhibition_name.cn.name || '' : item.exhibition_name && item.exhibition_name.en.name || ''}}</span>
                        </div>
                    </div>
                </template>
            </van-col>
        </van-row>
        <!-- 展品 -->
        <van-row style="padding:0 .28rem .28rem .28rem" v-show="isGoods">
            <van-col  class="goods-wrap"  v-for="(item, index) in goodsData" :key="index" span="8" @click="goProductDetail(item.company.id, item.exhibition.id, item.id)">
                <template>
                    <div class="exhibitior-wrap-img">
                        <img v-if="item.is_store == 0" @click.stop="collect(item)" class="new-store" src="~statics/mobileShouye/newUnstore.png">
                        <img v-if="item.is_store == 1" @click.stop="cancelCollect(item)" class="new-store" src="~statics/mobileShouye/newStore.png">
                        <img class="productImg" :src="item.product.cn.main_image && item.product.cn.main_image[0].url || logo " alt="" />
                    </div>
                    <div class="exhibitior-wrap-title">
                        <span class="exhibitior-wrap-title-name">{{item.product.cn.name}}</span>
                        <div class="company-place">
                            <span class="address">{{item.company.name || '暂无'}}</span>
                        </div>
                        <div class="exhibitor-place">
                            <span class="address">{{$t('header').exhibition}}：{{language == 'zh'? item.exhibition.base_info.data.cn.name: item.exhibition.base_info.data.en.name}}</span>
                        </div>
                    </div>
                </template>
            </van-col>
        </van-row>
        <van-empty
        v-show="isEmpty"
        class="custom-image"
        image="../../../../static/mobileShouye/empty-search.png"
        :description="this.$t('header').empty_tip"
        />
    </div>
</template>

<script>
import Headers from "./components/searchFooters"
import { mapState } from "vuex";
import api from "@/api";
import { all_exhibition_id } from "../../../utils/exhibitId"

export default {
    data(){
        return{
            logo: require("statics/no-logo-new.png"),
            exhibitorsList: [],
            goodsData: [],
            // title: '搜索页',
            optionsChooseCn: [{
            value: '100',
            label: '展商',
            }, {
            value: '101',
            label: '展品'
            }],
            optionsChooseEn: [{
            value: '100',
            label: 'Exhibitors',
            }, {
            value: '101',
            label: 'Exhibits'
            }],
            valuePavilion: '100',
            searchExhibitor: '',
            searchGoods: '',
            isEmpty: true,
            isExhibitors: false,
            isGoods: false,
            hasData: ''
        }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return  this.language == 'zh' ?  "搜索页" : "Search page"
        },
        ...mapState(["userInfo","language"]),
    },
    created() {

    },
    mounted(){
    },
    methods: {
        handleChoose(){
            
        },
        handleSearch(){
            if(this.valuePavilion == '100'){
                this.handleGetExhibitor()
            }else{
                this.handleGetExhibitionProduct()
            }
        },
        handleGetExhibitor(){
            api.getExhibitor({
                search: this.searchExhibitor,
                exhibition_id: all_exhibition_id
            }).then((res)=> {
                if(res.res ==1){
                    this.isExhibitors = true
                    this.isGoods = false
                    this.exhibitorsList = res.list
                    if(res.count > 0){
                        this.isEmpty = false
                    }else{
                        this.isEmpty = true
                    }
                }else{
                    this.$message.error(res.mes);
                }
            })
        },
        handleGetExhibitionProduct(){
            api.getExhibitionProduct({
                search: this.searchGoods,
                // language: this.language == 'zh' ? 'cn' : 'en',
                exhibition_id: all_exhibition_id
            }).then((res)=> {
                if(res.res ==1){
                    this.isGoods = true
                    if(res.count > 0){
                        this.isEmpty = false
                    }else{
                        this.isEmpty = true
                    }
                    this.isExhibitors = false
                    this.goodsData = res.list
                }else{
                    this.$message.error(res.mes);
                }
            })
        },
        goProductDetail(_company_id,_exhibition_id,_exhibition_product_id){
            this.$router.push({
                path: '/mobileAboutProductDetail',
                query: {
                    company_id: _company_id,
                    exhibition_id: _exhibition_id,
                    exhibition_product_id: _exhibition_product_id
                }
            })
        },
        goExhibitorDetail(_id,_exhibition_id,_vhall_id){
            this.$router.push({
               path: '/mobilezhanquDetaile',
               query:{
                 company_id: _id,
                 exhibition_id: _exhibition_id,
                 instance_id: _vhall_id
               }
            })
        },
        //展商收藏
        collectExhibitors(item) {
            if(!this.userInfo.id) {
                this.$notify({ type: 'danger',background: '#3a3c3f', message: '请先登录后收藏' });
                return
            }else{
                 api.isCollectExhibitors({
                    exhibition_id: item.exhibition_id,
                    company_id:  item.company.id 
                }).then((res) => {
                    console.log(res);
                    if (res.res == 1) {
                        item.is_store = 1;
                        this.$notify({ type: 'success', message: '收藏成功' });
                    }
                });
            }
        },
        cancelCollectExhibitors(item) {
            if(!this.userInfo.id) {
                this.$notify({ type: 'danger',background: '#3a3c3f', message: '请先登录后收藏' });
                return
            }else{
                api.noCollectExhibitors({
                    exhibition_id: item.exhibition_id,
                    company_id:  item.company.id
                }).then((res) => {
                    console.log(res);
                    if (res.res == 1) {
                        item.is_store = 0;
                        this.$notify("取消收藏");
                    }
                });
            }
        },
        //展品收藏
        collect(item) {
            if(!this.userInfo.id) {
                this.$notify({ type: 'danger',background: '#3a3c3f', message: '请先登录后收藏' });
                return
            }else{
                api.isCollectProduct({
                    exhibition_product_id: item.id
                }).then((res) => {
                    console.log(res);
                    if (res.res == 1) {
                        item.is_store = 1;
                        this.$notify({ type: 'success', message: '收藏成功' });
                    }
                });
            }
            
        },
        cancelCollect(item) {
            if(!this.userInfo.id) {
                this.$notify({ type: 'danger',background: '#3a3c3f', message: '请先登录后收藏' });
                return
            }else{
                api.noCollectProduct({
                    exhibition_product_id: item.id
                }).then((res) => {
                    console.log(res);
                    if (res.res == 1) {
                        item.is_store = 0;
                        this.$notify("取消收藏");
                    }
                });
            }
        },
    },
    components: {
        Headers,
    },
}
</script>

<style lang="scss" scoped>
/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}
/deep/ .el-select{
    width: 3.8rem;
}
/deep/ .el-input__inner{
    height: .6rem;
    line-height: .6rem;
    border-radius: 23px;
    border: unset;
    padding-left: .4rem;
    padding-right: unset;
    // width: 50%;
}
/deep/ .el-input{
    display: flex;
    align-items: center;
    width: unset;
}
/deep/ .el-input__suffix{
    position: unset;

}
/deep/ .el-select-dropdown{
    width: 1.5rem;
    min-width: unset;
}
.search-box{
    width: 7.5rem;
    height: 1.2rem;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    .search-input{
        display: flex;
        align-items: center;
        font-size: 14px;
        // width: 312px;
        height: .72rem;
        width: 6.9rem;
        border-radius: 23px;
        border: 1px solid #8390a8;
        // margin: .24rem auto;
        .icon {
            margin-right: 10px;
            width: 18px;
            height: 18px;
            cursor: pointer;
            margin-top: 2px;
        }
        .search-text{
            width: 100%;
            background: none;
            margin-right: 10px;
            color: #778DB3
        }
    }
}
.search-boxen{
    width: 7.5rem;
    height: 1.2rem;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    .search-input{
        display: flex;
        align-items: center;
        font-size: 14px;
        // width: 312px;
        height: .72rem;
        width: 6.9rem;
        border-radius: 23px;
        border: 1px solid #8390a8;
        // margin: .24rem auto;
        .icon {
            margin-right: 10px;
            width: 18px;
            height: 18px;
            cursor: pointer;
            margin-top: 2px;
        }
        .search-text{
            width: 100%;
            background: none;
            margin-right: 10px;
            color: #778DB3
        }
    }
}
.search-title{
    width: 7.1rem;
    height: .4rem;
    margin: .3rem auto .2rem;
    display: flex;
    align-items: center;
    .search{
        color: #999;
        line-height: .4rem;
        font-size: 14px;
        margin-right: .4rem;
    }
    .name{
        color: #999;
        line-height: .4rem;
        font-size: 14px;
        margin-right: .08rem;
    }
    .content{
        color: #333;
        line-height: .4rem;
        font-size: 14px;
    }
}
.custom-image{
    // position: absolute;
    // top: 0;
    // bottom: 0;
    // left: 0;
    // right: 0;
    // display: table;
    // margin: 0 auto;
}
/deep/ .van-empty__image {
    width: 1.2rem;
    height: 1.2rem;
}
.exhibitior-wrap{
    &:nth-child(odd){
        margin: .16rem .14rem .16rem 0;
    }
    &:nth-child(even){
        margin: .16rem 0;
    }
    height: 3.8rem;
    width: 3.4rem;
    background: #f2f7ff;
    border: 1px solid #e1e1ed;
    border-radius: 7px;
    .exhibitior-wrap-img{
        width: 3.36rem;
        height: 2.1rem;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .new-store{
            position: absolute;
            top: 0;
            left: 0;
            width: .4rem;
            height: .4rem;
        }
        img{
            max-width: 100%;
            max-height: 2.1rem;
            object-fit: contain;
            // padding: .1rem;
        }
    }
    .exhibitior-wrap-title{
        display: flex;
        flex-direction: column;
        height: 1.5rem;
        margin: .24rem 0 .14rem .22rem;
        .exhibitior-wrap-title-name{
            color: #333333;
            line-height: .4rem;
            height: .4rem;
            font-size: 14px;
            overflow: hidden; 
            white-space: nowrap; 
            text-overflow: ellipsis;
        }
        .company-place{
            display: flex;
            margin: .12rem 0 .12rem 0;
            .icon{
                width: .24rem;
                height: .28rem;
                margin-right: .12rem;
            }
            .address{
                color: #999999;
                line-height: .32rem;
                font-size: 12px;
                overflow: hidden; 
                white-space: nowrap; 
                text-overflow: ellipsis;
            }
        }
        .exhibitor-place{
            display: flex;
            margin: 0 0 .14rem 0;
            .address{
                color: #999999;
                line-height: .32rem;
                font-size: 12px;
                overflow: hidden; 
                white-space: nowrap; 
                text-overflow: ellipsis;
            }
        }
        .palce-store{
            display: flex;
            justify-content: space-between;
            margin-top: .12rem;
            .store{
                display: flex;
                .store-icon{
                    width: .24rem;
                    height: .24rem;
                }
                .store-name{
                    line-height: .3rem;
                    color: #999;
                    font-size: 12px;
                }
            }
        }
    }
}
.goods-wrap{
    &:nth-child(odd){
        margin: .16rem .14rem .16rem 0;
    }
    &:nth-child(even){
        margin: .16rem 0;
    }
    height: 5.08rem;
    width: 3.4rem;
    background:#fff;
    border-radius: 6px;
    .exhibitior-wrap-img{
        border-bottom: 1px solid #e1e1ed;
        width: 3.36rem;
        height: 3.4rem;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .new-store{
            position: absolute;
            top: 0;
            left: 0;
            width: .4rem;
            height: .4rem;
        }
        img{
            max-width: 100%;
            max-height: 3.4rem;
            object-fit: contain;
            // padding: .08rem;
        }
    }
    .exhibitior-wrap-title{
        display: flex;
        flex-direction: column;
        height: 1.5rem;
        margin: .24rem 0 .14rem .22rem;
        .exhibitior-wrap-title-name{
            color: #333333;
            line-height: .4rem;
            height: .4rem;
            font-size: 14px;
            overflow: hidden; 
            white-space: nowrap; 
            text-overflow: ellipsis;
        }
        .company-place{
            display: flex;
            margin: .12rem 0 .12rem 0;
            .icon{
                width: .24rem;
                height: .28rem;
                margin-right: .12rem;
            }
            .address{
                color: #999999;
                line-height: .32rem;
                font-size: 12px;
                overflow: hidden; 
                white-space: nowrap; 
                text-overflow: ellipsis;
            }
        }
        .exhibitor-place{
            display: flex;
            margin: 0 0 .14rem 0;
            .address{
                color: #999999;
                line-height: .32rem;
                font-size: 12px;
                overflow: hidden; 
                white-space: nowrap; 
                text-overflow: ellipsis;
            }
        }
        .palce-store{
            display: flex;
            justify-content: space-between;
            margin-top: .12rem;
            .store{
                display: flex;
                .store-icon{
                    width: .24rem;
                    height: .24rem;
                }
                .store-name{
                    line-height: .3rem;
                    color: #999;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileSearch/index.vue